<template>
  <div class="text-group">
    <template v-if="!invert">
      <p class="utext ma-0" style="white-space: pre-line" :class="{ 'text-small': smallHeader }">
        {{ utext }}
      </p>
      <p
        class="btext"
        style="white-space: pre-line"
        :class="[
          tgap,
          {
            'text-large': large,
            'text-xl': xl,
            'btext-bold': btextBold,
          },
        ]"
      >
        {{ btext }}
      </p>
    </template>
    <template v-else>
      <p
        class="btext"
        style="white-space: pre-line"
        :class="{ 'text-large': large, 'text-xl': xl, 'btext-bold': btextBold }"
      >
        {{ btext }}
      </p>
      <p
        class="utext"
        style="white-space: pre-line"
        :class="[tgap, { 'text-small': smallHeader, 'ma-0': !tgap }]"
      >
        {{ utext }}
      </p>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    utext: {
      type: [String, Number, Boolean],
      default: 'utext',
    },
    btext: {
      type: null,
      default: 'btext',
    },
    large: Boolean,
    xl: Boolean,
    smallHeader: Boolean,
    btextBold: {
      type: Boolean,
      default: true,
    },
    invert: Boolean,
    gap: Number, //zvacsi medzeru medzi hornym a spodnym textom v px
  },
  computed: {
    tgap() {
      return this.gap ? `mt-${this.gap}px` : '';
    },
  },
};
</script>
